import { useRequest } from "ahooks";
import { API_ENDPOINT } from "@/config/endpoint/endpoint";

interface RestaurantFilters {
  category?: string | null;
  price?: number | null;
  award?: string | null;
}

export const useFetchRestaurants = (filters: RestaurantFilters = {}) => {
  // null 값들을 제거하고 params 객체 생성
  const params = Object.fromEntries(
    Object.entries(filters).filter(([_, value]) => value !== null && value !== undefined && value !== '')
  );
  
  const cacheKey = `restaurants-${JSON.stringify(params)}`;
  
  return useRequest(() => API_ENDPOINT.places.getRestaurants(Object.keys(params).length > 0 ? params : undefined), {
    cacheKey,
    refreshDeps: [JSON.stringify(params)], // 필터가 변경되면 자동으로 새로운 데이터 요청
  });
};

export const useFetchRestaurantsFilters = () => {
  return useRequest(() => API_ENDPOINT.places.getRestaurantsFilters(), {
    cacheKey: `restaurants-filters`,
  });
};

export const useFetchRestaurantDetail = (id: string) => {
  return useRequest(() => API_ENDPOINT.places.getRestaurantDetail(id), {
    cacheKey: `restaurant-detail-${id}`,
  });
};